export default function(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-interpolate/src/round.js
// module id = 564
// module chunks = 0